import * as st from "lib/utils/socialtravel";
import BaseDecorator from "./BaseDecorator";

export default class InstallmentDecorator extends BaseDecorator {
  get isFirstInstallment() {
    return this.position === 0;
  }

  get isLastInstallment() {
    return this.amount_type === "remaining_amount";
  }

  get transfer_type_i18n() {
    return I18n.humanAttributeName("order_installment", this.transfer_type);
  }

  get balance_status_i18n() {
    return I18n.humanAttributeName("order_installment", this.balance_status);
  }

  get description_formatted() {
    return [this.amount_formatted, this.transfer_type_i18n, this.confirmation_formatted, this.paid_by_at_formatted]
      .filter((s) => !!s)
      .join("; ");
  }

  get confirmation_formatted() {
    if (this.confirmation_installment) {
      if (this.paid_after_company_approval) {
        return I18n.humanAttributeName("installment", "confirmation_after_company_approval");
      } else {
        return I18n.humanAttributeName("installment", "confirmation_before_company_approval");
      }
    }
  }

  get amount_formatted() {
    let amount;
    if (this.amount_type === "exact_amount_per_order") {
      amount = st.formatMoney(this.amount) + " " + I18n.t("attributes.per_order");
    } else if (this.amount_type === "exact_amount_per_item") {
      amount = st.formatMoney(this.amount) + " " + I18n.t("attributes.per_item");
    } else if (this.amount_type === "exact_amount_per_person") {
      amount = st.formatMoney(this.amount) + " " + I18n.t("attributes.per_person");
    } else if (this.amount_type === "exact_amount") {
      amount = st.formatMoney(this.amount);
    } else if (this.amount_type === "percentage_amount") {
      amount = st.formatPercentage(this.amount_percentage);
    } else if (this.amount_type === "remaining_amount") {
      amount = this.isFirstInstallment
        ? I18n.humanAttributeName("installment", "whole_amount")
        : I18n.humanAttributeName("installment", "remaining_amount");
    }
    if (this.increase_amount_by_marketplace_service_fee) {
      amount += " + " + I18n.humanAttributeName("order", "marketplace_service_fee");
    }
    if (this.increase_amount_by_marketplace_commision) {
      amount += " + " + I18n.humanAttributeName("order", "marketplace_commision");
    }
    return amount;
  }

  get amount_or_percentage() {
    if (this.amount) {
      return this.amount;
    } else {
      return {
        value: this.amount_percentage,
        currency: "percentage",
      };
    }
  }

  set amount_or_percentage(amount_or_percentage) {
    if (!amount_or_percentage) {
      this.amount = null;
      this.amount_percentage = null;
    } else if (amount_or_percentage.currency === "percentage") {
      this.amount_type = "percentage_amount";
      this.amount = null;
      this.amount_percentage = amount_or_percentage.value;
    } else {
      this.amount_type =
        this.type === "PaymentProfileInstallment"
          ? this.is_exact_amount
            ? this.amount_type
            : "exact_amount_per_order"
          : "exact_amount";
      this.amount = amount_or_percentage;
      this.amount_percentage = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/InstallmentDecorator.js